import React from 'react';
import './MeetTheTeam.css';

const MeetTheTeam = () => {
    // Board member data with explicit ordering
    const boardMembers = [
        { order: 1, name: "Brett B.", imageFile: "BrettB.JPEG" },
        { order: 2, name: "Dr. Reginald", imageFile: "DrReginald.JPEG" },
        { order: 3, name: "David S.", imageFile: "DavidS.JPEG" },
        { order: 4, name: "Tom Luca", imageFile: "TomLuca.JPEG" },
        { order: 5, name: "Amrat C.", imageFile: "AmratC.JPEG" },
        { order: 6, name: "Morena D.", imageFile: "MorenaD.JPEG" },
        { order: 7, name: "Ryan H.", imageFile: "RyanH.JPEG" },
        { order: 8, name: "Fabricia A.", imageFile: "FabriciaA.JPEG" },
        { order: 9, name: "Jacob R.", imageFile: "JacobR.JPEG" },
        { order: 10, name: "Kyathi U.", imageFile: "KyathiU.JPEG" },
        { order: 11, name: "Haylee R.", imageFile: "HayleeR.JPEG" },
        { order: 12, name: "Shaniya M.", imageFile: "ShaniyaM.JPEG" },
        { order: 13, name: "Valarie W.", imageFile: "ValarieW.JPEG" },
        { order: 14, name: "Jordan D.", imageFile: "JordanD.JPEG" },
        { order: 15, name: "Emmanuel P.", imageFile: "EmmanuelP.JPEG" }
    ];

    return (
        <div className="col-md-8 mx-auto text-center" style={{ paddingTop: '80px' }}>
            {/* Hero Section */}
            <div className="container py-5">
                <h1 className="team-title">Meet The Team</h1>
                <div className='team-line'></div>
                <p className="lead">
                    <b>The PilotHelper team is comprised of pilots, doctors, flight attendants, and aviation professionals dedicated to strengthening aviation safety by equipping the pilot community with aviation-specific peer support training.</b>
                </p>
                <div className='team-line'></div>
            </div>
           
            {/* Team Members Grid */}
            <section className="team-grid-section">
                <div className="container">
                    <div className="team-grid">
                        {boardMembers.map((member) => (
                            <div key={member.order} className="team-member">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/${member.imageFile}`}
                                    alt={member.name}
                                    className="team-member-image"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MeetTheTeam;